import Vue from 'vue';

const inserted = (el, binding, vnode) => {
  const value = binding.value;
  const modifiers = binding.modifiers || {};

  const { onObserver, options } = typeof value === 'object'
    ? value
    : { onObserver: value, options: {} };

  const observerFn = (entries, ctx) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      onObserver({ entry, entries, observer: ctx });

      if (modifiers.once) {
        unbind(el, binding, vnode);
      }
    });
  };

  const observer = new IntersectionObserver(observerFn, {
    threshold: 0.99,
    ...options,
  });

  el._observe = Object();
  el._observe[vnode.context._uid] = { observer };

  observer.observe(el);
};

const unbind = (el, _binding, vnode) => {
  const observe = el._observe?.[vnode.context._uid];

  if (!observe) return;

  observe.observer.unobserve(el);
  observe.observer.disconnect();
  delete el._observe[vnode.context._uid];
};

Vue.directive('observe', { inserted, unbind });
